// Agendamiento real (backend → Calendar de HumanX). Antes de las 9:00 del 16-oct invita solo a Jhonny; luego también a Carlos.
export async function agendarReal(datos) {
  try {
    const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/agenda`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      // Sesión #6: el backend interpreta la franja en la hora del usuario, no en la del servidor
      body: JSON.stringify({ ...datos, tz: Intl.DateTimeFormat().resolvedOptions().timeZone || '' }),
    });
    return await r.json();
  } catch (e) {
    return { ok: false, error: String(e) };
  }
}
